module.exports = __webpack_public_path__ + "img/bonus2.86ba6f2c.png";